export default {
  "hero.title": "USFans Spreadsheet — Encuentra, compara e investiga recursos de USFans",
  "hero.subtitle": "Explora recursos de USFans Spreadsheet, guías prácticas, información de vendedores, comparaciones, información de envío y consejos de seguridad — todo organizado en un centro de recursos fácil de usar.",
  "hero.support": "¿Buscas una forma más clara de investigar recursos de USFans? Empieza con nuestras guías organizadas de USFans Spreadsheet, comparaciones y herramientas de investigación prácticas.",
  "hero.ctaPrimary": "Explorar USFans Spreadsheet",
  "hero.ctaSecondary": "Empezar con la guía para principiantes",
  "hero.badge": "Centro de recursos independiente",

  "trust.1": "Recurso independiente",
  "trust.2": "Guías actualizadas",
  "trust.3": "Contenido multilingüe",
  "trust.4": "Investigación centrada en la seguridad",

  "jump.title": "Visita nuestra tienda",
  "jump.subtitle": "¿Listo para explorar la gama completa de productos? Ve directamente a la tienda oficial.",
  "jump.primary": "USFans Spreadsheet",
  "jump.secondary": "Comprar ahora",

  "whatIs.title": "¿Qué es USFans Spreadsheet?",
  "whatIs.text": "USFans Spreadsheet se usa comúnmente para organizar e investigar información de productos, vendedores y compras. Nuestro centro de recursos ayuda a principiantes y usuarios experimentados a comprender la información de la hoja de cálculo, comparar opciones, evaluar detalles importantes e investigar con más cuidado.",
  "whatIs.cta": "Explorar la guía de USFans Spreadsheet",

  "research.title": "Todo lo que necesitas para investigar USFans",
  "research.subtitle": "Un conjunto estructurado de recursos que cubren los ángulos más importantes al investigar USFans.",
  "research.spreadsheet.title": "USFans Spreadsheet",
  "research.spreadsheet.text": "Explora el recurso principal de la hoja de cálculo y aprende a leer e investigar información.",
  "research.review.title": "Reseñas de USFans",
  "research.review.text": "Comprende qué revisar al investigar reseñas, reputación y experiencias de usuarios de USFans.",
  "research.shipping.title": "Costo de envío de USFans",
  "research.shipping.text": "Aprende qué factores pueden afectar los costos de envío y qué información comparar.",
  "research.warehouse.title": "Almacén de USFans",
  "research.warehouse.text": "Comprende la información relacionada con el almacén, conceptos de almacenamiento y preguntas comunes.",
  "research.coupon.title": "Cupón de USFans",
  "research.coupon.text": "Aprende a investigar cupones, promociones e información de descuentos de USFans.",
  "research.safety.title": "Seguridad de USFans",
  "research.safety.text": "Identifica riesgos comunes, afirmaciones sospechosas y consideraciones de seguridad importantes.",

  "compare.title": "Compara recursos de USFans antes de decidir",
  "compare.text": "Diferentes recursos pueden proporcionar distintos niveles de información. Usa nuestras guías de comparación para evaluar categorías, información disponible, detalles de control de calidad, información de envío y posibles limitaciones antes de tomar una decisión.",
  "compare.cta": "Ver comparaciones de USFans",

  "beginner.title": "¿Nuevo en USFans? Empieza aquí.",
  "beginner.subtitle": "Una ruta sencilla de tres pasos para investigar con más confianza.",
  "beginner.step1.title": "Encuentra",
  "beginner.step1.text": "Descubre recursos relevantes de USFans Spreadsheet.",
  "beginner.step2.title": "Compara",
  "beginner.step2.text": "Compara la información disponible y comprende las diferencias.",
  "beginner.step3.title": "Investiga",
  "beginner.step3.text": "Revisa la seguridad, el envío, el almacén y otros detalles importantes.",
  "beginner.cta": "Leer la guía completa para principiantes",

  "guides.title": "Guías de USFans: reseñas, envío, almacén y descuentos",
  "guides.subtitle": "Recursos dedicados a los temas que más busca la gente.",
  "guides.review.title": "Reseñas de USFans",
  "guides.review.text": "Qué revisar antes de confiar en una reseña.",
  "guides.shipping.title": "Costo de envío de USFans",
  "guides.shipping.text": "Factores que afectan las tarifas de envío.",
  "guides.coupon.title": "Cupón de USFans",
  "guides.coupon.text": "Cómo investigar promociones.",
  "guides.discount.title": "Código de descuento de USFans",
  "guides.discount.text": "Qué revisar antes de usar uno.",
  "guides.warehouse.title": "Almacén de USFans",
  "guides.warehouse.text": "Conceptos de almacenamiento y preguntas comunes.",
  "guides.legit.title": "¿USFans es legítimo?",
  "guides.legit.text": "Señales de legitimidad y precaución.",

  "category.title": "Explora productos por categoría",
  "category.subtitle": "Ve directamente a cualquier categoría de productos en la tienda.",
  "category.dropdownLabel": "Elige una categoría",
  "category.all": "Todas las categorías",

  "article.title": "Últimas guías de USFans Spreadsheet",
  "article.subtitle": "Guías frescas y originales para ayudarte a investigar con confianza.",

  "safety.title": "Centro de seguridad de USFans Spreadsheet",
  "safety.text": "La investigación de compras en línea requiere una verificación cuidadosa. Nuestro centro de seguridad explica cómo identificar información sospechosa, evaluar afirmaciones, proteger la información personal y verificar detalles importantes antes de actuar.",
  "safety.cta": "Leer la guía de seguridad",

  "faq.title": "Preguntas frecuentes",
  "faq.q1": "¿Qué es USFans Spreadsheet?",
  "faq.a1": "USFans Spreadsheet es una forma de organizar e investigar información de productos, vendedores y compras en un solo lugar, facilitando la comparación de opciones y la evaluación de detalles.",
  "faq.q2": "¿Cómo funciona USFans Spreadsheet?",
  "faq.a2": "Organiza información estructurada como productos, vendedores, precios y detalles de envío en columnas y filas, para que puedas escanear y comparar datos de forma más eficiente.",
  "faq.q3": "¿Cómo leo una USFans Spreadsheet?",
  "faq.a3": "Empieza con los encabezados de las columnas y luego sigue cada fila para comprender los datos de un producto o vendedor específico. Revisa las columnas clave como nombre, precio, control de calidad y envío.",
  "faq.q4": "¿USFans es legítimo?",
  "faq.a4": "La legitimidad depende de la fuente que estés revisando. Siempre verifica la información, busca detalles verificables y ten cuidado con afirmaciones que parezcan demasiado buenas para ser verdad.",
  "faq.q5": "¿Cuánto cuesta el envío de USFans?",
  "faq.a5": "Los costos de envío varían según el destino, el peso, el transportista y otros factores. Compara varias fuentes y confirma el costo final antes de comprar.",
  "faq.q6": "¿USFans tiene cupones?",
  "faq.a6": "Las promociones y cupones pueden aparecer con el tiempo. Verifica cualquier cupón o código de descuento directamente y ten cuidado con ofertas no oficiales o no verificables.",
  "faq.q7": "¿Dónde está el almacén de USFans?",
  "faq.a7": "Los detalles del almacén pueden cambiar. Consulta fuentes oficiales o actualizadas para obtener la información más precisa sobre ubicación y almacenamiento.",
  "faq.q8": "¿Cómo puedo verificar la información de USFans?",
  "faq.a8": "Compara varias fuentes independientes, busca fechas y actualizaciones, y confirma los detalles clave directamente antes de tomar decisiones.",

  "final.title": "¿Listo para explorar USFans Spreadsheet?",
  "final.text": "Empieza con la guía de USFans Spreadsheet, compara recursos relevantes y aprende a investigar información importante con mayor confianza.",
  "final.ctaPrimary": "Explorar USFans Spreadsheet",
  "final.ctaSecondary": "Explorar todas las guías"
};